import {Model} from '@/models/Model'
import {DataArray, DataResource, FilterSet} from '@/models/Response'
import Helper from '../services/Helper.js'

export class Product extends Model {
    declare id: number
    created_at: Date | null
    updated_at: Date | null
    name: string | null
    short_name: string | null
    nickname: string | null
    nickcode: string | null
    detail: string | null
    code: string | null
    type: string | null
    type_code: string | null
    group: string | null
    color: string | null
    size: string | null
    erp_code2: string | null
    erp_barcode: string | null
    price_retail: number | null
    dimension_width: number | null
    dimension_height: number | null
    dimension_long: number | null
    volume: number | null
    weight: number | null
    image_path: string | null
    stock_MT: number | null
    reserve_MT: number | null
    stock_PJ: number | null


    price_MT: number | null
    price_PJ: number | null
    price_TT: number | null

    unit_single: string | null
    unit_primitive: string | null
    unit_prim_rate: number | null

    price_1: number | null
    price_2: number | null
    price_3: number | null
    price_4: number | null
    price_5: number | null
    price_6: number | null
    price_7: number | null
    price_8: number | null
    price_9: number | null
    price_10: number | null

    mode: string | null

    non_over_stock: boolean | null

    item_from: string | null

    getResourceURL(): string {
        return Helper.setting.product.getResourceAPI
    }
}

export class DataProductsArray extends DataArray {

    declare data: Product[]
    filter: FilterProduct = new FilterProduct()
}


export class DataProduct extends DataResource {
    declare data: Product
}


export class ProductTop {
    declare id: number
    name: string | null
    nickname: string | null
    code: string | null
}

export class DataProductTopArray extends DataArray {
    declare data: ProductTop[]
}


export class FilterProduct {

    type: FilterSet = new FilterSet([{key: 'F', text: 'สินค้าสำเร็จรูป', count: 0, active: false}])
    group: FilterSet = new FilterSet()
    color: FilterSet = new FilterSet()
    size: FilterSet = new FilterSet()
}
